/** Max students selectable for one bulk delete (matches backend BULK_DELETE_LIMIT). */
export const BULK_DELETE_LIMIT = 100;

export const BULK_DELETE_LIMIT_MESSAGE =
  `You can select up to ${BULK_DELETE_LIMIT} students at a time for bulk delete. Deselect some or delete in batches.`;

export function isSelectionAtLimit(selectedCount, limit = BULK_DELETE_LIMIT) {
  return selectedCount >= limit;
}

/**
 * Toggle one student in/out of the selection, enforcing the limit when adding.
 * @returns {{ selection: object[], limitReached: boolean }}
 */
export function toggleStudentInSelection(selected, student, limit = BULK_DELETE_LIMIT) {
  if (!student?.id) {
    return { selection: selected, limitReached: false };
  }

  const isSelected = selected.some((s) => s.id === student.id);
  if (isSelected) {
    return {
      selection: selected.filter((s) => s.id !== student.id),
      limitReached: false
    };
  }

  if (selected.length >= limit) {
    return { selection: selected, limitReached: true };
  }

  return {
    selection: [...selected, student],
    limitReached: false
  };
}

/** Select up to `limit` students from a list (e.g. select-all in table). */
export function selectStudentsUpToLimit(candidates, limit = BULK_DELETE_LIMIT) {
  return candidates.slice(0, limit);
}

/** Whether every item in `candidates` (up to limit) is already selected. */
export function isAllSelectableSelected(selected, candidates, limit = BULK_DELETE_LIMIT) {
  const selectable = selectStudentsUpToLimit(candidates, limit);
  if (selectable.length === 0) return false;
  return selectable.every((s) => selected.some((sel) => sel.id === s.id));
}
